import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-add-farmhouse',
  templateUrl: './add-farmhouse.component.html',
  styleUrl: './add-farmhouse.component.scss'
})
export class AddFarmhouseComponent {
  @Input() farmHouseFormGroup: FormGroup;
  @Input() index: number;
  @Output() removeFarmHouseEvent = new EventEmitter<number>();
  @Output() addFarmHousePartitionEvent = new EventEmitter<number>();
  openFarmIndex: number = 0;

  constructor(private fb: FormBuilder) {}

  get farmHousePartitions(): FormArray {
    return this.farmHouseFormGroup.get('farmHousePartitions') as FormArray;
  }

  addFarmHousePartition(): void {
    this.addFarmHousePartitionEvent.emit(this.index);
  }

  removeFarmHouse(): void {
    this.removeFarmHouseEvent.emit(this.index);
  }

  removeFarmHousePartition(partitionIndex: number): void {
    if (this.farmHousePartitions.length > 1) {
      this.farmHousePartitions.removeAt(partitionIndex);
    }
  }
  setOpenFarm(index: number): void {
    this.openFarmIndex = this.openFarmIndex === index ? null : index;
  }
  isControlInvalid(controlName: string): boolean {
    const control = this.farmHouseFormGroup.get(controlName);
    return control?.invalid && (control.touched || control.dirty);
  }
}
